<template>
  <TrainerLayout>
    <div class="">
      <h3 class="font-semibold text-3xl leading-10 tracking-tight mb-8 mt-2">
        Edit Profile
      </h3>
      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
        <div class="w-full px-2 md:w-1/3">
          <label class="block required text-gray-smoke font-medium text-sm md:text-lg mb-2"> First Name </label>
          <input
            class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
            placeholder="First Name"
            v-model="$v.f_name.$model"
            :classStr="{ 'ring-red-700': $v.f_name.$error }"
          />
          <div v-if="$v.f_name.$error">
            <span class="text-red-700" v-if="!$v.f_name.required">
              First Name is required
            </span>
          </div>
        </div>

        <div class="w-full px-2 md:w-1/3">
          <div class="text-gray-700">
            <label class="block required text-gray-smoke font-medium text-sm md:text-lg mb-2"> Last Name </label>
            <input
              class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              placeholder="Last Name"
              v-model="$v.l_name.$model"
              :classStr="{ 'ring-red-700': $v.l_name.$error }"
            />
            <div v-if="$v.l_name.$error">
              <span class="text-red-700 text-xs" v-if="!$v.l_name.required">
                Last Name is required
              </span>
            </div>
          </div>
        </div>

        <div class="w-full px-2 md:w-1/3">
          <div class="text-gray-700">
            <label class="block text-gray-smoke font-medium text-sm md:text-lg mb-2">Date of Birth</label>
            <DropdownDatepicker
              :dropdownClass="'text-gray-slate w-full pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md'"
              v-if="selectedDate"
              display-format="mdy"
              v-model="$v.selectedDate.$model"
              v-bind:required="true"
              v-bind:min-age="13"
              :default-date="selectedDate"
              submit-format="dd-mm-yyyy"
            ></DropdownDatepicker>
            <div v-if="$v.selectedDate.$error">
              <p class="text-red-700 text-xs" v-if="!$v.selectedDate.required">
                Date of Birth is required
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
        <div class="w-full px-2 md:w-1/3">
          <div class="text-gray-700">
            <label class="block required text-gray-smoke font-medium text-sm md:text-lg mb-2">Instagram Link </label>
            <input
              class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              v-model="$v.insta_link.$model"
              :classStr="{ 'ring-red-700': $v.insta_link.$error }"
            />
            <div v-if="$v.insta_link.$error">
              <span class="text-red-700 text-xs" v-if="!$v.insta_link.url">
                Accepts only URLs.
              </span>
            </div>
          </div>
        </div>

        <div class="w-full px-2 md:w-1/3">
          <div class="text-gray-700">
            <label class="block required text-gray-smoke font-medium text-sm md:text-lg mb-2">Facebook Link </label>
            <input
              class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              v-model="$v.fb_link.$model"
            />
            <div v-if="$v.fb_link.$error">
              <span class="text-red-700 text-xs" v-if="!$v.fb_link.url"
                >Accepts only URLs.</span
              >
            </div>
          </div>
        </div>

        <div class="w-full px-2 md:w-1/3">
          <div class="text-gray-700">
            <label class="block text-gray-smoke font-medium text-sm md:text-lg mb-2">Mobile Number </label>
            <VuePhoneNumberInput
              v-model="$v.mobile.$model"
              :error="$v.nationalMobile.$error"
              :no-example="true"
              @update="
                (nationalMobile = $event.nationalNumber),
                  (isd_code = $event.countryCode)
              "
              :default-country-code="isd_code"
              class=""
            />
            <div v-if="$v.nationalMobile.$error">
              <span
                class="text-red-700 text-xs"
                v-if="!$v.nationalMobile.minLength"
              >
                Mobile must have at least 10 digits.
              </span>
              <span
                class="text-red-700 text-xs"
                v-if="!$v.nationalMobile.maxLength"
              >
                Mobile must have at Most 10 digits.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap mt-4">
        <div class="w-full">
          <div class="text-gray-700">
            <label class="block required text-gray-smoke font-medium text-sm md:text-lg mb-2"> About me </label>
            <textarea
              class="h-24 w-full text-gray-slate pl-3 pr-3 border-1 border-borderColor focus:outline-none rounded-md"
              placeholder="Trainer Description..."
              v-model="$v.description.$model"
            ></textarea>
            <div v-if="$v.description.$error">
              <span
                class="text-red-700 text-xs"
                v-if="!$v.description.required"
              >
                About Me is required
              </span>
              <span
                class="text-red-700 text-xs"
                v-if="!$v.description.minLength"
              >
                Must be at least 25 characters.
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
        <div class="w-full px-2 md:w-1/3">
          <LanguageInput
            :languagesList="languagesList"
            :languagesData="languagesData"
            :languages="languages"
            @LanguagesChange="handleLanguagesChange"
            @LanguagesRemove="handleLanguagesRemove"
          />
        </div>

        <div class="w-full px-2 md:w-1/3">
          <CategoryInput
            :categoriesList="categoriesList"
            :categoriesData="categoriesData"
            :category_id="category_id"
            @CategoriesChange="handleCategoryChange"
            @CategoriesRemove="handleCategoryRemove"
          />
        </div>

        <div class="w-full px-2 md:w-1/3">
          <!-- <div class="mb-4 text-gray-700">
            <label class="block text-sm font-medium text-gray-700 required">
              Private Class
              <span class="text-sm text-gray-500">
                (Set to 0, if not available)
              </span>
            </label>
            <div class="mt-1 relative rounded-md shadow-sm">
              <div
                class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
              >
                <span class="text-gray-500 sm:text-sm"> $ </span>
              </div>
              <input
                class="w-full h-10 px-6 text-base placeholder-gray-600 ring-1 ring-gray-light rounded-lg focus:outline-none"
                type="text"
                v-model="$v.private_cost.$model"
              />
              <div
                class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
              >
                <span class="text-gray-500 sm:text-sm" id="price-currency">
                  Per Hour
                </span>
              </div>
            </div>
            <div v-if="$v.private_cost.$error">
              <span
                class="text-red-700 text-xs"
                v-if="!$v.private_cost.required"
              >
                Private Class is Required
              </span>
            </div>
          </div> -->

          <div class="relative inline-block w-full text-gray-700">
            <label class="block required text-gray-smoke font-medium text-sm md:text-lg mb-2" for="forms-labelOverInputCode">
              Update your timezone
            </label>
            <!-- <select
              class="w-full h-10 pl-3 pr-6 text-base placeholder-gray-600 border rounded-lg appearance-none focus:shadow-outline"
              v-model="selectedTimezone"
              @change="changeTimezone($event)"
            >
              <option>Select your timezone</option>
              <option
                v-for="(t, i) in getTimezoneDetails"
                :key="i"
                :value="t.id"
              >
                {{ t.display_name }}
              </option>
            </select> -->
            <model-list-select
              :list="getTimezoneDetails"
              v-model="selectedTimezone"
              option-value="id"
              option-text="display_name"
              placeholder="select item"
              class="text-gray-slate w-full pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
            >
            </model-list-select>
          </div>
        </div>
      </div>
      <div class="flex space-x-6 justify-end mt-4">
        <div class="mb-4">
          <router-link
            class="inline-flex items-center h-10 w-20 px-4 m-2 text-green-light transition-colors duration-150 ring-green-light ring-1 rounded-lg focus:outline-none hover:bg-green-light hover:text-white"
            :to="{ name: 'TrainerProfileAbout' }"
          >
            Back
          </router-link>
          <button
            class="h-10 w-20 px-4 m-2 text-green-100 transition-colors duration-150 bg-green-dark rounded-lg focus:outline-none hover:bg-green-dark hover:shadow-lg"
            @click="handleEditProfile"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import LanguageInput from "@/components/t-components/LanguageInput";
import CategoryInput from "@/components/t-components/CategoryInput";
import DropdownDatepicker from "@/components/vue-dropdown-datepicker/dropdown-datepicker";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";


export default {
  name: "TrainerProfileEdit",
  components: {
    TrainerLayout,
    DropdownDatepicker,
    VuePhoneNumberInput,
    LanguageInput,
    CategoryInput,
    ModelListSelect,
  },
  data() {
    return {
      f_name: "",
      l_name: "",
      selectedDate: "",
      insta_link: "",
      fb_link: "",
      nationalMobile: "",
      isd_code: "",
      mobile: "",
      description: "",
      private_cost: "",
      languages: "",
      languagesData: [],
      category_id: "",
      categoriesData: [],
      profile: [],
      selectedTimezone: null,
    };
  },
  validations: {
    f_name: {
      required,
    },
    l_name: {
      required,
    },
    selectedDate: {
      // required,
    },
    insta_link: {
      isUrlValid(insta_link) {
        var regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
        if (regex.test(insta_link)) {
          return true;
        } else {
          if (insta_link == null || insta_link == "") {
            return true;
          } else {
            return false;
          }
        }
      },
    },
    fb_link: {
      isUrlValid(fb_link) {
        var regex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
        if (regex.test(fb_link)) {
          return true;
        } else {
          if (fb_link == null || fb_link == "") {
            return true;
          } else {
            return false;
          }
        }
      },
    },
    mobile: {
      minLength: minLength(10),
    },
    description: {
      required,
      minLength: minLength(25),
    },
    private_cost: {
      required,
    },
    languages: {
      required,
    },
    category_id: {
      required,
    },
    categoriesData: {
      required,
      maxLength: maxLength(4),
    },
    nationalMobile: {
      maxLength: maxLength(10),
      minLength: minLength(10),
    },
    languagesData: {
      required,
    },
  },
  computed: {
    ...mapGetters([
      "trainerProfile",
      "languagesList",
      "categoriesList",
      "getTimezoneDetails",
    ]),
  },
  methods: {
    ...mapActions([
      "getTrainerProfile",
      "trainerProfileUpdate",
      "getLanguagesList",
      "getCategoriesList",
      "timezone",
    ]),

    handleLanguagesChange(event) {
      const data = {
        id: event.target.value,
        text: event.target.options[event.target.options.selectedIndex].text,
      };
      if (data.id == "") {
        return;
      }
      const index = this.languagesData.findIndex((e) => e.id === data.id);
      if (index === -1) {
        this.languagesData.push(data);
        this.languages = data.id;
      }
    },

    handleCategoryChange(event) {
      const data = {
        id: event.target.value,
        text: event.target.options[event.target.options.selectedIndex].text,
      };
      if (data.id == "") {
        return;
      }
      const index = this.categoriesData.findIndex((e) => e.id === data.id);
      if (index === -1) {
        this.categoriesData.push(data);
        this.category_id = data.id;
      }
    },

    handleCategoryRemove(id) {
      const index = this.categoriesData.findIndex((e) => e.id === id);
      if (index !== -1) {
        this.categoriesData.splice(index, 1);
        this.category_id = this.categoriesData[0].id;
      }
    },

    handleLanguagesRemove(id) {
      const index = this.languagesData.findIndex((e) => e.id === id);
      if (index !== -1) {
        this.languagesData.splice(index, 1);
        this.languages = this.languagesData[0].id;
      }
    },

    // changeTimezone(event) {
    //   this.selectedTimezone = event.target.value;
    // },

    async handleEditProfile() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const data = new FormData();

        data.append("f_name", this.f_name);
        data.append("l_name", this.l_name);
        data.append("dob", this.selectedDate);
        data.append("timezone", this.selectedTimezone);
        if (this.insta_link) {
          data.append("insta_link", this.insta_link);
        }
        if (this.fb_link) {
          data.append("fb_link", this.fb_link);
        }
        data.append("description", this.description);
        data.append("private_cost", this.private_cost);
        if (this.mobile) {
          data.append("isd_code", this.isd_code);
          data.append("mobile", this.nationalMobile);
        }
        for (var i = 0; i < this.languagesData.length; i++) {
          data.append("language_id[" + i + "]", this.languagesData[i].id);
        }
        for (var i = 0; i < this.categoriesData.length; i++) {
          data.append("category_id[" + i + "]", this.categoriesData[i].id);
        }
        await this.trainerProfileUpdate(data);
        this.$router.push({ name: "TrainerProfileAbout" });
      }
    },

    getLanguagesData(ids, names) {
      const idsArray = ids.split(",");
      const namesArray = names.split(",");
      idsArray.forEach((e, i) => {
        this.languagesData.push({ id: e, text: namesArray[i] });
      });
    },

    getCategoriesData(ids, names) {
      const idsArray = ids.split(",");
      const namesArray = names.split(",");
      idsArray.forEach((e, i) => {
        this.categoriesData.push({ id: e, text: namesArray[i] });
      });
    },
  },
  async created() {
    this.getLanguagesList();
    this.getCategoriesList();
    await this.getTrainerProfile();
    this.profile = this.trainerProfile.profile;
    this.f_name = this.profile.f_name;
    this.l_name = this.profile.l_name;
    this.selectedDate =
      this.trainerProfile &&
      this.trainerProfile.profile &&
      this.trainerProfile.profile.dob;
    this.insta_link =
      this.profile && this.profile.insta_link
        ? this.profile && this.profile.insta_link
        : "";
    this.fb_link =
      this.profile && this.profile.fb_link
        ? this.profile && this.profile.fb_link
        : "";
    this.isd_code = this.profile.isd_code;
    this.nationalMobile = this.profile.mobile;
    this.mobile = this.nationalMobile;
    this.description = this.profile.description;
    this.private_cost = this.profile.private_cost;
    this.selectedTimezone = this.profile.timezone;
    this.languages =
      this.profile &&
      this.profile.language_ids &&
      this.profile.language_ids.split(",") &&
      this.profile.language_ids.split(",")[0];
    this.category_id =
      this.profile &&
      this.profile.category_ids &&
      this.profile.category_ids.split(",") &&
      this.profile.category_ids.split(",")[0];
    this.getLanguagesData(
      this.profile.language_ids,
      this.profile.language_names
    );
    this.getCategoriesData(
      this.profile.category_ids,
      this.profile.category_name
    );
    await this.timezone();
  },
};
</script>

<style>
  /* .ui.selection.dropdown>.delete.icon, 
  .ui.selection.dropdown>.dropdown.icon, 
  .ui.selection.dropdown>.search.icon{
    top: 14px;
  } */
  /* .ui.fluid.dropdown{
    padding-top: 17px;
    
  } */
</style>